import _construct from "/Users/mleroux/Web/landing/node_modules/@babel/runtime/helpers/esm/construct";
import _toConsumableArray from "/Users/mleroux/Web/landing/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/Users/mleroux/Web/landing/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/Users/mleroux/Web/landing/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/Users/mleroux/Web/landing/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["blendFunction", "opacity"],
    _excluded2 = ["target", "depthTexture"],
    _excluded3 = ["active"],
    _excluded4 = ["size"],
    _excluded5 = ["selection", "selectionLayer", "blendFunction", "patternTexture", "edgeStrength", "pulseSpeed", "visibleEdgeColor", "hiddenEdgeColor", "width", "height", "kernelSize", "blur", "xRay"],
    _excluded6 = ["textureSrc", "texture"],
    _excluded7 = ["lut", "tetrahedralInterpolation"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { BlendFunction as e, BloomEffect as t, BrightnessContrastEffect as n, ChromaticAberrationEffect as r, ColorAverageEffect as i, ColorDepthEffect as o, DepthEffect as l, EffectComposer as c, RenderPass as s, NormalPass as a, EffectPass as u, DepthOfFieldEffect as d, DotScreenEffect as m, GlitchEffect as f, GlitchMode as p, GodRaysEffect as h, GridEffect as g, HueSaturationEffect as b, NoiseEffect as w, OutlineEffect as E, PixelationEffect as y, ScanlineEffect as v, SelectiveBloomEffect as S, SepiaEffect as x, SSAOEffect as T, SMAAPreset as j, EdgeDetectionMode as C, SMAAImageLoader as L, SMAAEffect as P, TextureEffect as A, ToneMappingEffect as R, VignetteEffect as O, ShockWaveEffect as z, LUTEffect as F } from "postprocessing";
import B, { forwardRef as D, useMemo as I, useLayoutEffect as M, createContext as k, useEffect as N, useRef as _, useImperativeHandle as G, useContext as H } from "react";
import { Vector2 as U, Vector3 as Y, TextureLoader as q, sRGBEncoding as V, RepeatWrapping as W } from "three";
import { useThree as J, useFrame as K, useLoader as Q } from "@react-three/fiber";

var X = function X(t) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e.NORMAL;
  return D(function (_ref, o) {
    var e = _ref.blendFunction,
        r = _ref.opacity,
        i = _objectWithoutProperties(_ref, _excluded);

    var l = I(function () {
      return new t(i);
    }, [i]);
    return M(function () {
      l.blendMode.blendFunction = e || n, void 0 !== r && (l.blendMode.opacity.value = r);
    }, [e, l.blendMode, r]), B.createElement("primitive", {
      ref: o,
      object: l,
      dispose: null
    });
  });
},
    Z = function Z(e, t) {
  var n = e[t];
  return I(function () {
    if (n instanceof U) return new U().set(n.x, n.y);

    if (Array.isArray(n)) {
      var _n = _slicedToArray(n, 2),
          _e = _n[0],
          _t = _n[1];

      return new U().set(_e, _t);
    }
  }, [n]);
},
    $ = function $() {
  try {
    var _e2 = document.createElement("canvas");

    return !(!window.WebGL2RenderingContext || !_e2.getContext("webgl2"));
  } catch (e) {
    return !1;
  }
},
    ee = X(t, e.SCREEN),
    te = X(n),
    ne = D(function (e, t) {
  var n = Z(e, "offset"),
      i = I(function () {
    return new r(_objectSpread(_objectSpread({}, e), {}, {
      offset: n
    }));
  }, [n, e]);
  return B.createElement("primitive", {
    ref: t,
    object: i,
    dispose: null
  });
}),
    re = D(function (_ref2, n) {
  var _ref2$blendFunction = _ref2.blendFunction,
      t = _ref2$blendFunction === void 0 ? e.NORMAL : _ref2$blendFunction;
  var r = I(function () {
    return new i(t);
  }, [t]);
  return B.createElement("primitive", {
    ref: n,
    object: r,
    dispose: null
  });
}),
    ie = X(o),
    oe = X(l),
    le = k(null),
    ce = B.memo(D(function (_ref3, p) {
  var e = _ref3.children,
      t = _ref3.camera,
      n = _ref3.scene,
      _ref3$renderPriority = _ref3.renderPriority,
      r = _ref3$renderPriority === void 0 ? 1 : _ref3$renderPriority,
      _ref3$autoClear = _ref3.autoClear,
      i = _ref3$autoClear === void 0 ? !0 : _ref3$autoClear,
      o = _ref3.depthBuffer,
      l = _ref3.disableNormalPass,
      d = _ref3.stencilBuffer,
      _ref3$multisampling = _ref3.multisampling,
      m = _ref3$multisampling === void 0 ? 8 : _ref3$multisampling,
      f = _ref3.frameBufferType;

  var _J = J(),
      h = _J.gl,
      g = _J.scene,
      b = _J.camera,
      w = _J.size;

  n = n || g, t = t || b;

  var _I = I(function () {
    var e = new c(h, {
      depthBuffer: o,
      stencilBuffer: d,
      multisampling: $() ? m : 0,
      frameBufferType: f
    });
    e.addPass(new s(n, t));
    var r = l ? null : new a(n, t);
    return r && e.addPass(r), [e, r];
  }, [t, h, o, d, m, f, n, l]),
      _I2 = _slicedToArray(_I, 2),
      E = _I2[0],
      y = _I2[1];

  N(function () {
    return null == E ? void 0 : E.setSize(w.width, w.height);
  }, [E, w]), K(function (e, t) {
    return h.autoClear = i, void E.render(t);
  }, r);

  var v = _(null);

  N(function () {
    var e;
    return v.current && v.current.__r3f && E && (e = _construct(u, [t].concat(_toConsumableArray(v.current.__r3f.objects))), E.addPass(e), e.renderToScreen = !0), function () {
      e && (null == E || E.removePass(e));
    };
  }, [E, e, t]);
  var S = I(function () {
    return {
      composer: E,
      normalPass: y,
      camera: t,
      scene: n
    };
  }, [E, y, t, n]);
  return G(p, function () {
    return E;
  }, [E]), B.createElement(le.Provider, {
    value: S
  }, B.createElement("group", {
    ref: v
  }, e));
})),
    se = D(function (_ref4, r) {
  var e = _ref4.target,
      t = _ref4.depthTexture,
      n = _objectWithoutProperties(_ref4, _excluded2);

  var _H = H(le),
      i = _H.camera,
      o = I(function () {
    return new d(i, n);
  }, [i, n]);

  return M(function () {
    if (e) {
      var _t2 = e instanceof Y ? new Y().set(e.x, e.y, e.z) : new Y().set(e[0], e[1], e[2]);

      o.target = _t2;
    }

    t && o.setDepthTexture(t.texture, t.packing);
  }, [e, t, o]), B.createElement("primitive", {
    ref: r,
    object: o,
    dispose: null
  });
}),
    ae = X(m),
    ue = D(function (_ref5, n) {
  var _ref5$active = _ref5.active,
      e = _ref5$active === void 0 ? !0 : _ref5$active,
      t = _objectWithoutProperties(_ref5, _excluded3);

  var r = Z(t, "delay"),
      i = Z(t, "duration"),
      o = Z(t, "strength"),
      l = I(function () {
    return new f(_objectSpread(_objectSpread({}, t), {}, {
      delay: r,
      duration: i,
      strength: o
    }));
  }, [r, i, t, o]);
  return M(function () {
    l.mode = e ? t.mode || p.SPORADIC : p.DISABLED;
  }, [e, l, t.mode]), B.createElement("primitive", {
    ref: n,
    object: l,
    dispose: null
  });
}),
    de = D(function (e, t) {
  var _H2 = H(le),
      n = _H2.camera,
      r = I(function () {
    return new h(n, e.sun, e);
  }, [n, e]);

  return B.createElement("primitive", {
    ref: t,
    object: r,
    dispose: null
  });
}),
    me = D(function (_ref6, n) {
  var e = _ref6.size,
      t = _objectWithoutProperties(_ref6, _excluded4);

  var r = I(function () {
    return new g(t);
  }, [t]);
  return M(function () {
    e && r.setSize(e.width, e.height);
  }, [r, e]), B.createElement("primitive", {
    ref: n,
    object: r,
    dispose: null
  });
}),
    fe = X(b),
    pe = X(w, e.COLOR_DODGE),
    he = D(function (_ref7, p) {
  var _ref7$selection = _ref7.selection,
      e = _ref7$selection === void 0 ? [] : _ref7$selection,
      _ref7$selectionLayer = _ref7.selectionLayer,
      t = _ref7$selectionLayer === void 0 ? 10 : _ref7$selectionLayer,
      n = _ref7.blendFunction,
      r = _ref7.patternTexture,
      i = _ref7.edgeStrength,
      o = _ref7.pulseSpeed,
      l = _ref7.visibleEdgeColor,
      c = _ref7.hiddenEdgeColor,
      s = _ref7.width,
      a = _ref7.height,
      u = _ref7.kernelSize,
      d = _ref7.blur,
      m = _ref7.xRay,
      f = _objectWithoutProperties(_ref7, _excluded5);

  var _H3 = H(le),
      h = _H3.scene,
      g = _H3.camera,
      b = I(function () {
    return new E(h, g, {
      blendFunction: n,
      patternTexture: r,
      edgeStrength: i,
      pulseSpeed: o,
      visibleEdgeColor: l,
      hiddenEdgeColor: c,
      width: s,
      height: a,
      kernelSize: u,
      blur: d,
      xRay: m
    });
  }, [n, d, g, i, a, c, u, r, o, h, l, s, m]);

  return N(function () {
    b.clearSelection(), b.setSelection(Array.isArray(e) ? e.map(function (e) {
      return e.current;
    }) : [e.current]);
  }, [b, e]), N(function () {
    b.selectionLayer = t;
  }, [b, t]), B.createElement("primitive", {
    ref: p,
    object: b,
    dispose: null
  });
}),
    ge = D(function (_ref8, t) {
  var _ref8$granularity = _ref8.granularity,
      e = _ref8$granularity === void 0 ? 5 : _ref8$granularity;
  var n = I(function () {
    return new y(e);
  }, [e]);
  return B.createElement("primitive", {
    ref: t,
    object: n,
    dispose: null
  });
}),
    be = X(v, e.OVERLAY),
    we = D(function (_ref9, u) {
  var _ref9$selection = _ref9.selection,
      t = _ref9$selection === void 0 ? [] : _ref9$selection,
      _ref9$selectionLayer = _ref9.selectionLayer,
      n = _ref9$selectionLayer === void 0 ? 10 : _ref9$selectionLayer,
      _ref9$lights = _ref9.lights,
      r = _ref9$lights === void 0 ? [] : _ref9$lights,
      i = _ref9.luminanceThreshold,
      o = _ref9.luminanceSmoothing,
      l = _ref9.intensity,
      c = _ref9.width,
      s = _ref9.height,
      a = _ref9.kernelSize;
  0 === r.length && console.warn("SelectiveBloom requires lights to work.");

  var _H4 = H(le),
      d = _H4.scene,
      m = _H4.camera,
      f = I(function () {
    return new S(d, m, {
      blendFunction: e.SCREEN,
      luminanceThreshold: i,
      luminanceSmoothing: o,
      intensity: l,
      width: c,
      height: s,
      kernelSize: a
    });
  }, [m, s, l, a, o, i, d, c]);

  return N(function () {
    f.selection.set(Array.isArray(t) ? t.map(function (e) {
      return e.current;
    }) : [t.current]);
  }, [f, t]), N(function () {
    f.selection.layer = n;
  }, [f, n]), N(function () {
    return r.forEach(function (e) {
      return function (e, t) {
        e.current && e.current.layers.enable(t.selection.layer);
      }(e, f);
    }), function () {
      return r.forEach(function (e) {
        return function (e, t) {
          e.current && e.current.layers.disable(t.selection.layer);
        }(e, f);
      });
    };
  }, [f, r, n]), B.createElement("primitive", {
    ref: u,
    object: f,
    dispose: null
  });
}),
    Ee = X(x),
    ye = D(function (t, n) {
  var _H5 = H(le),
      r = _H5.camera,
      i = _H5.normalPass,
      o = I(function () {
    return null === i ? (console.error("Please enable the NormalPass in the EffectComposer in order to use SSAO."), null) : new T(r, i.renderTarget.texture, _objectSpread({
      blendFunction: e.MULTIPLY,
      samples: 30,
      rings: 4,
      distanceThreshold: 1,
      distanceFalloff: 0,
      rangeThreshold: .5,
      rangeFalloff: .1,
      luminanceInfluence: .9,
      radius: 20,
      scale: .5,
      bias: .5
    }, t));
  }, [r, i, t]);

  return B.createElement("primitive", {
    ref: n,
    object: o,
    dispose: null
  });
}),
    ve = D(function (_ref10, n) {
  var _ref10$preset = _ref10.preset,
      e = _ref10$preset === void 0 ? j.HIGH : _ref10$preset,
      _ref10$edgeDetectionM = _ref10.edgeDetectionMode,
      t = _ref10$edgeDetectionM === void 0 ? C.COLOR : _ref10$edgeDetectionM;
  var r = Q(L, ""),
      i = I(function () {
    return _construct(P, _toConsumableArray(r).concat([e, t]));
  }, [r, e, t]);
  return B.createElement("primitive", {
    ref: n,
    object: i,
    dispose: null
  });
}),
    Se = D(function (_ref11, r) {
  var e = _ref11.textureSrc,
      t = _ref11.texture,
      n = _objectWithoutProperties(_ref11, _excluded6);

  var i = Q(q, e);
  M(function () {
    i.encoding = V, i.wrapS = i.wrapT = W;
  }, [i]);
  var o = I(function () {
    return new A(_objectSpread(_objectSpread({}, n), {}, {
      texture: i || t
    }));
  }, [n, i, t]);
  return B.createElement("primitive", {
    ref: r,
    object: o,
    dispose: null
  });
}),
    xe = X(R),
    Te = X(O),
    je = X(z),
    Ce = D(function (_ref12, r) {
  var e = _ref12.lut,
      t = _ref12.tetrahedralInterpolation,
      n = _objectWithoutProperties(_ref12, _excluded7);

  var i = I(function () {
    return new F(e, n);
  }, [e, n]);
  return M(function () {
    e && i.setLUT(e), t && i.setTetrahedralInterpolationEnabled(t);
  }, [i, e, t]), B.createElement("primitive", {
    ref: r,
    object: i,
    dispose: null
  });
});

export { ee as Bloom, te as BrightnessContrast, ne as ChromaticAberration, re as ColorAverage, ie as ColorDepth, oe as Depth, se as DepthOfField, ae as DotScreen, ce as EffectComposer, le as EffectComposerContext, ue as Glitch, de as GodRays, me as Grid, fe as HueSaturation, Ce as LUT, pe as Noise, he as Outline, ge as Pixelation, ve as SMAA, ye as SSAO, be as Scanline, we as SelectiveBloom, Ee as Sepia, je as ShockWave, Se as Texture, xe as ToneMapping, Te as Vignette };